import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../store/store";

interface CarePlanUIState {
  expandedGroupIds: number[];
}

const initialState: CarePlanUIState = {
  // Start with no expanded groups; component can open "Current" on mount if needed.
  expandedGroupIds: [],
};

const carePlanUISlice = createSlice({
  name: "carePlanUI",
  initialState,
  reducers: {
    setExpandedGroups(state, action: PayloadAction<number[]>) {
      state.expandedGroupIds = action.payload;
    },

    toggleGroup(state, action: PayloadAction<number>) {
      const id = action.payload;
      state.expandedGroupIds = state.expandedGroupIds.includes(id)
        ? state.expandedGroupIds.filter((x) => x !== id)
        : [...state.expandedGroupIds, id];
    },

    resetExpandedGroups(state) {
      state.expandedGroupIds = [];
    },
  },
});

export const { setExpandedGroups, toggleGroup, resetExpandedGroups } =
  carePlanUISlice.actions;

export const selectExpandedGroupIds = (state: RootState) =>
  state.carePlanUI.expandedGroupIds;

export default carePlanUISlice.reducer;
